export const PATTERN = {
    MM_DD_YYYY_DATE_FORMAT : /^\d{1,2}\/\d{1,2}\/\d{4}$/,
    ISO_DATE_ONLY_REGEX : /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/,
    MM_DD_YYYY_DATE_EXTRACT :  /\b\d{2}\/\d{2}\/\d{4}\b/g,
}